<template>
  <div class="hero-banner">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          Claritone科睿通 <span class="highlight">®</span>
        </h1>
        <h2 class="hero-subtitle">
          一站式医学<span class="btn-highlight">AI科研平台</span>
        </h2>
        <p class="hero-description">
            复旦交大团队自研模型，医学SCI出版社自用SKILL。
        </p>
      </div>
      
      <div class="hero-icons">
        <div class="icon-item icon-1">✏️</div>
        <div class="icon-item icon-2">📋</div>
        <div class="icon-item icon-3">✕</div>
        <div class="icon-item icon-4">💡</div>
        <div class="icon-item icon-5">📝</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroBanner'
}
</script>

<style scoped>
.hero-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 24px;
  margin: 30px auto;
  max-width: 1200px;
  padding: 80px 60px;
  position: relative;
  overflow: hidden;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero-text {
  flex: 1;
  max-width: 600px;
}

.hero-title {
  font-size: 48px;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
  line-height: 1.2;
}

.highlight {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 20px;
  font-weight: 500;
}

.btn-highlight {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 20px;
  border-radius: 50px;
  color: #ffffff;
  font-weight: 600;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.8;
  margin-top: 20px;
}

.hero-icons {
  position: relative;
  width: 300px;
  height: 300px;
}

.icon-item {
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  animation: float 3s ease-in-out infinite;
}

.icon-1 {
  top: 20px;
  left: 50px;
  animation-delay: 0s;
}

.icon-2 {
  top: 80px;
  right: 40px;
  animation-delay: 0.5s;
}

.icon-3 {
  bottom: 100px;
  left: 30px;
  animation-delay: 1s;
}

.icon-4 {
  bottom: 60px;
  right: 60px;
  animation-delay: 1.5s;
}

.icon-5 {
  top: 150px;
  left: 150px;
  animation-delay: 2s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
}

@media (max-width: 968px) {
  .hero-banner {
    padding: 60px 30px;
    margin: 20px;
  }
  
  .hero-content {
    flex-direction: column;
    text-align: center;
  }
  
  .hero-text {
    max-width: 100%;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .hero-subtitle {
    font-size: 20px;
  }
  
  .hero-icons {
    width: 250px;
    height: 250px;
    margin-top: 40px;
  }
}

@media (max-width: 768px) {
  .hero-banner {
    padding: 40px 20px;
  }
  
  .hero-title {
    font-size: 28px;
  }
  
  .hero-subtitle {
    font-size: 18px;
  }
  
  .hero-description {
    font-size: 14px;
  }
}
</style>
